import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt } from '@/features/dashboard-finance/formatters';

/** Barras com os 10 países com mais tenants. */
export function TenantsByCountryBarChart({
  data,
}: {
  data: readonly { country: string; count: number }[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const points = data.map((d) => ({ x: d.country, y: d.count }));
  return (
    <BiTimeChart
      title={t('usageBasic.charts.tenantsByCountry')}
      type="bar"
      data={points}
      color="#0ea5e9"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
